// extracted by mini-css-extract-plugin
module.exports = {"marginBox":"ContentSeparator-module--marginBox--2oOSt","contentSeparator":"ContentSeparator-module--contentSeparator--3TEPt"};